














import Proxyable from '@/mixins/proxyable';
import { IPayrollChangeRequest } from '@/models';
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Proxyable.extend({
  name: 'PayrollChangeRequestAPSpecialistPicker',

  props: {
    payrollChangeRequest: {
      type: Object as PropType<IPayrollChangeRequest>,
      required: true
    },
    externalErrorMessage: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      loading: false,
      errorMessage: ''
    };
  },

  computed: {
    ...mapGetters({
      hrPersonnels: 'payrollChangeRequest/getPayrollChangeRequestHRPersonnels'
    }),

    errorMessageList(): string[] {
      const errorList = [];
      if (this.externalErrorMessage) {
        errorList.push(this.externalErrorMessage);
      }
      if (this.errorMessage) {
        errorList.push(this.errorMessage);
      }

      return errorList;
    }
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    this.errorMessage = '';
  },

  methods: {
    ...mapActions({
      fetchPayrollChangeRequestHRPersonnels:
        'payrollChangeRequest/fetchPayrollChangeRequestHRPersonnels'
    }),

    init() {
      this.loading = true;

      this.fetchPayrollChangeRequestHRPersonnels(this.payrollChangeRequest.id)
        .catch(() => {
          this.errorMessage = 'Error getting AP Specialists';
        })
        .finally(() => (this.loading = false));
    }
  }
});
